<button mat-stroked-button (click)="button()" matTooltip="Show on map">
    <div class="mat-caption" *ngIf="text">
        {{ text }}
    </div>
    <mat-icon aria-label="map">{{ icon }}</mat-icon>
</button>